import { PerformanceByYearLineItem } from '@components/performanceByYearLineItem';
import { useFragment } from 'react-relay';
import { performanceByYearFragment } from './PerformanceByYear.relay';
import type { PerformanceByYearProps } from './types';

export const PerformanceByYear: React.FC<PerformanceByYearProps> = ({ component }) => {
  const data = useFragment(performanceByYearFragment, component);

  return (
    <div className="Widget-row mb-16 flex w-full flex-wrap items-start justify-between max-[1100px]:w-full max-[600px]:mb-8">
      <div className="Widget-header mb-4 w-full border-b border-black text-left font-heading text-2xl leading-[1.3] text-black max-[700px]:text-base max-[700px]:leading-6 [&>span]:inline-block [&>span]:border-b [&>span]:border-accent [&>span]:-mb-px">
        <span>{data.performanceTitle}</span>
      </div>
      <div className="Widget-row mb-12 flex w-full flex-wrap items-start justify-between max-[1100px]:w-full max-[600px]:mb-8">
        <div className="Widget-col w-[45%] max-[1100px]:w-full">
          <div className="PerformanceByYear-entries">
            {data.lineItems.slice(0, 6).map((lineItem, idx) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: no stable id available
              <PerformanceByYearLineItem key={`performanceByYearFirstItem-${idx}`} component={lineItem} />
            ))}
          </div>
        </div>
        <div className="Widget-col w-[45%] max-[1100px]:w-full">
          <div className="PerformanceByYear-entries">
            {data.lineItems.slice(6).map((lineItem, idx) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: no stable id available
              <PerformanceByYearLineItem key={`performanceByYearSecondItem-${idx}`} component={lineItem} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
